<template>
  <div class="product-feature-module">
    <!-- <h3 class="h3_title"><span>产品特色</span></h3> -->
    <div class="production-box">
      <div class="production-list">
        <img :src="cdnresources+'/uat/images/SJB/01.png'" />
        <img :src="cdnresources+'/uat/images/SJB/02.png'" />
      </div>
      <!-- <div class="production-list">
        <img :src="cdnresources+'/uat/images/SJB/baiwanbaozhang.png'" />
      </div>
      <div class="production-list">
        <img :src="cdnresources+'/uat/images/SJB/buchongyiliao.png'" />
      </div> -->
      <!-- <div class="flexcent">
        <div class="production-list">
          <img :src="cdnresources+'/uat/images/SJB/yaopin.png'" />
        </div>
        <div class="textHref" @click="showDrugDetail = true">
          <a>更多高值药品目录详见《更多详情》</a>
          <img :src="cdnresources+'/uat/images/SJB/blue.png'" />
        </div>
      </div> -->
      <!-- <div class="production-list">
        <img :src="cdnresources+'/uat/images/SJB/gezhangzhif.png'" />
      </div>
      <div class="production-list">
        <img :src="cdnresources+'/uat/images/SJB/quanjt.png'" />
      </div> -->
    </div>
    <pdf-action-sheet v-model="showDrugDetail" :style-obj="{ height: '70%' }" title="药品目录">
      <drug-catalogue/>
    </pdf-action-sheet>
  </div>
</template>
<script>
import { cdnresources } from '@/util/config'
import PdfActionSheet from '@/views/PdfFiles/PdfActionSheet'
import DrugCatalogue from '@/views/PdfFiles/DrugCatalogue'
export default {
  data() {
    return {
      cdnresources,
      showDrugDetail: false
    }
  },
  components:{
    PdfActionSheet,
    DrugCatalogue
  }
}
</script>
<style lang="scss" scoped>
.product-feature-module{
  background: #fff;
  .h3_title{
    margin: 0px;
    position: relative;
    padding: xvw(30) xvw(30) xvw(38) xvw(30);
    font-size: xvw(38);
    font-weight: 600;
    color: #333;
    span{
      position: relative;
      z-index: 3;
    }
    &::before{
      content: '';
      position: absolute;
      width: xvw(151);
      height: xvw(19);
      background: #FFF1F1;
      bottom: xvw(40);
    }
    &::after{
      content: '';
      background:url('../../../assets/img/insu_detail/title-inc.png') no-repeat;
      background-size: 100%;
      width: xvw(80);
      height: xvw(38);
      margin-left: xvw(14);
      display: inline-block;
      vertical-align: bottom;
    }
  }
  .production-box {
    font-size: px2rem(30);
    position: relative;
    .production-list {
      font-size: 0px;
      text-align: center;
      margin-bottom: 0px;
      & > img {
        width: 100%;
        margin:0px
      }
    }
  }
  .flexcent{
    display:flex;
    position: relative;
    justify-content: space-around;
  }
  .textHref {
    position: absolute;
    bottom: 7%;
    width: auto;
    text-align: center;
    font-size: xvw(28);
    color: #4D76F9;
    cursor: pointer;
    border-radius: xvh(50);
    white-space: nowrap;
    border: pxrem(2) solid #D8D8D8;
    padding:xvh(6) pxrem(28) xvh(10) pxrem(28); 
    margin: 0 auto;
    img{
      width: pxrem(24);
      height: pxrem(24);
      vertical-align: baseline;
    }
  }
}
</style>
